import { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { BottomNav } from './BottomNav'
import { NotificationBell } from '../../../modules/notifications/components'
import logoSvg from '../../../assets/logo.svg'

interface MobileLayoutProps {
  children: ReactNode
  title?: string
  showHeader?: boolean
  showBottomNav?: boolean
  className?: string
}

export function MobileLayout({
  children,
  title,
  showHeader = true,
  showBottomNav = true,
  className = '',
}: MobileLayoutProps) {
  return (
    <div className={`mobile-layout ${className}`}>
      {showHeader && (
        <header className="mobile-layout__header">
          <Link to="/" className="mobile-layout__logo">
            <img src={logoSvg} alt="" className="mobile-layout__logo-icon" />
            <span className="mobile-layout__logo-text">Rondela</span>
          </Link>
          {title && <h1 className="mobile-layout__title">{title}</h1>}
          <div className="mobile-layout__actions">
            <NotificationBell />
          </div>
        </header>
      )}

      <main className="mobile-layout__content">{children}</main>

      {showBottomNav && <BottomNav />}
    </div>
  )
}
